import React from 'react'

const Exam = () => {
  return (
    <div >
        <h2 style={{margin:"100px"}}>Coming Soon...</h2>
    </div>
  )
}

export default Exam